/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddGuildBody,
  AddGuildQuestBody,
  ApiError,
  ClaimGuildQuestResponse,
  CreateSponsoredCompetitionBody,
  DuplicateSponsoredCompetitionBody,
  GetCompetitionInfoResponse,
  GetCurrentGuildTopMembersResponse,
  GetGlobalMonthlyGuildLeaderboardResponse,
  GetGuildOwnershipResponse,
  GetGuildProgressResponse,
  GetGuildQuestsResponse,
  GetGuildsResponse,
  GetGuildsSort,
  GetQuestActiveStatus,
  GetSponsoredGuildCompetitionsResponse,
  GetTopGuildLeadersLeaderboardResponse,
  GetTopGuildsLeaderboardResponse,
  Guild,
  NftMintTransaction,
  SortOrder,
  UpdateSponsoredCompetitionBody,
} from '../models/index';
import {
    AddGuildBodyFromJSON,
    AddGuildBodyToJSON,
    AddGuildQuestBodyFromJSON,
    AddGuildQuestBodyToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    ClaimGuildQuestResponseFromJSON,
    ClaimGuildQuestResponseToJSON,
    CreateSponsoredCompetitionBodyFromJSON,
    CreateSponsoredCompetitionBodyToJSON,
    DuplicateSponsoredCompetitionBodyFromJSON,
    DuplicateSponsoredCompetitionBodyToJSON,
    GetCompetitionInfoResponseFromJSON,
    GetCompetitionInfoResponseToJSON,
    GetCurrentGuildTopMembersResponseFromJSON,
    GetCurrentGuildTopMembersResponseToJSON,
    GetGlobalMonthlyGuildLeaderboardResponseFromJSON,
    GetGlobalMonthlyGuildLeaderboardResponseToJSON,
    GetGuildOwnershipResponseFromJSON,
    GetGuildOwnershipResponseToJSON,
    GetGuildProgressResponseFromJSON,
    GetGuildProgressResponseToJSON,
    GetGuildQuestsResponseFromJSON,
    GetGuildQuestsResponseToJSON,
    GetGuildsResponseFromJSON,
    GetGuildsResponseToJSON,
    GetGuildsSortFromJSON,
    GetGuildsSortToJSON,
    GetQuestActiveStatusFromJSON,
    GetQuestActiveStatusToJSON,
    GetSponsoredGuildCompetitionsResponseFromJSON,
    GetSponsoredGuildCompetitionsResponseToJSON,
    GetTopGuildLeadersLeaderboardResponseFromJSON,
    GetTopGuildLeadersLeaderboardResponseToJSON,
    GetTopGuildsLeaderboardResponseFromJSON,
    GetTopGuildsLeaderboardResponseToJSON,
    GuildFromJSON,
    GuildToJSON,
    NftMintTransactionFromJSON,
    NftMintTransactionToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    UpdateSponsoredCompetitionBodyFromJSON,
    UpdateSponsoredCompetitionBodyToJSON,
} from '../models/index';

export interface CreateGuildQuestsRequest {
    addGuildQuestBody?: AddGuildQuestBody;
}

export interface CreateGuildQuestsIdClaimRequest {
    id: string;
    guildId: string;
    gameId: string;
    rewardConfigId?: string;
    body?: object;
}

export interface CreateGuildsRequest {
    addGuildBody?: AddGuildBody;
}

export interface CreateGuildsIdJoinRequest {
    id: string;
    body?: object;
}

export interface CreateGuildsIdMintRequest {
    id: string;
    body?: object;
}

export interface CreateSponsoredGuildCompetitionsRequest {
    createSponsoredCompetitionBody?: CreateSponsoredCompetitionBody;
}

export interface CreateSponsoredGuildCompetitionsIdDuplicateRequest {
    id: string;
    duplicateSponsoredCompetitionBody?: DuplicateSponsoredCompetitionBody;
}

export interface GetCompetitionInfoRequest {
    test?: boolean;
}

export interface GetCronDistributeSponsorshipPrizesRequest {
    competitionId?: string;
}

export interface GetGlobalMonthlyGuildLeaderboardLeaderboardTimeParamRequest {
    leaderboardTimeParam: string;
}

export interface GetGuildQuestsRequest {
    game?: string;
    guild?: string;
    search?: string;
    isActive?: GetQuestActiveStatus;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetGuildsRequest {
    gameIds?: Array<string>;
    search?: string;
    sort?: GetGuildsSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetGuildsIdRequest {
    id: string;
}

export interface GetGuildsIdProgressRequest {
    id: string;
    freshCopy?: boolean;
}

export interface GetSponsoredGuildCompetitionsRequest {
    search?: string;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetTopGuildLeadersLeaderboardTimeParamRequest {
    leaderboardTimeParam: string;
}

export interface GetTopGuildsLeaderboardTimeParamRequest {
    leaderboardTimeParam: string;
}

export interface GetUserGuildTopMembersLeaderboardTimeParamRequest {
    leaderboardTimeParam: string;
}

export interface UpdateCompetitionsWonDismissIdRequest {
    id: string;
    body?: object;
}

export interface UpdateGuildQuestsIdRequest {
    id: string;
    addGuildQuestBody?: AddGuildQuestBody;
}

export interface UpdateGuildsIdRequest {
    id: string;
    addGuildBody?: AddGuildBody;
}

export interface UpdateSponsoredGuildCompetitionsRequest {
    updateSponsoredCompetitionBody?: UpdateSponsoredCompetitionBody;
}

/**
 * GuildsApi - interface
 * 
 * @export
 * @interface GuildsApiInterface
 */
export interface GuildsApiInterface {
    /**
     * Used to create new Guild quest
     * @param {AddGuildQuestBody} [addGuildQuestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    createGuildQuestsRaw(requestParameters: CreateGuildQuestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to create new Guild quest
     */
    createGuildQuests(requestParameters: CreateGuildQuestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Should allow a user to claim a guild-specific quest reward.
     * @param {string} id 
     * @param {string} guildId 
     * @param {string} gameId 
     * @param {string} [rewardConfigId] 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    createGuildQuestsIdClaimRaw(requestParameters: CreateGuildQuestsIdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimGuildQuestResponse>>;

    /**
     * Should allow a user to claim a guild-specific quest reward.
     */
    createGuildQuestsIdClaim(requestParameters: CreateGuildQuestsIdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimGuildQuestResponse>;

    /**
     * Adds a new guild to the system
     * @param {AddGuildBody} [addGuildBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    createGuildsRaw(requestParameters: CreateGuildsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Guild>>;

    /**
     * Adds a new guild to the system
     */
    createGuilds(requestParameters: CreateGuildsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Guild>;

    /**
     * Should allow a user to join a guild.
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    createGuildsIdJoinRaw(requestParameters: CreateGuildsIdJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Should allow a user to join a guild.
     */
    createGuildsIdJoin(requestParameters: CreateGuildsIdJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Should mint the guild proof of play badge to the user\'s wallet.
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    createGuildsIdMintRaw(requestParameters: CreateGuildsIdMintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NftMintTransaction>>;

    /**
     * Should mint the guild proof of play badge to the user\'s wallet.
     */
    createGuildsIdMint(requestParameters: CreateGuildsIdMintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NftMintTransaction>;

    /**
     * Used to create new Guild quest
     * @param {CreateSponsoredCompetitionBody} [createSponsoredCompetitionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    createSponsoredGuildCompetitionsRaw(requestParameters: CreateSponsoredGuildCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to create new Guild quest
     */
    createSponsoredGuildCompetitions(requestParameters: CreateSponsoredGuildCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Duplicate an existing sponsored guild competition to a new month/year
     * @param {string} id 
     * @param {DuplicateSponsoredCompetitionBody} [duplicateSponsoredCompetitionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    createSponsoredGuildCompetitionsIdDuplicateRaw(requestParameters: CreateSponsoredGuildCompetitionsIdDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Duplicate an existing sponsored guild competition to a new month/year
     */
    createSponsoredGuildCompetitionsIdDuplicate(requestParameters: CreateSponsoredGuildCompetitionsIdDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Should allow a user to leave a guild.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    deleteGuildsLeaveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Should allow a user to leave a guild.
     */
    deleteGuildsLeave(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Gets any current competition + last months competition and winners
     * @param {boolean} [test] Return test payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    getCompetitionInfoRaw(requestParameters: GetCompetitionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitionInfoResponse>>;

    /**
     * Gets any current competition + last months competition and winners
     */
    getCompetitionInfo(requestParameters: GetCompetitionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitionInfoResponse>;

    /**
     * Used to get businesses owned by the current merchant, or all businesses if user is admin
     * @param {string} [competitionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    getCronDistributeSponsorshipPrizesRaw(requestParameters: GetCronDistributeSponsorshipPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to get businesses owned by the current merchant, or all businesses if user is admin
     */
    getCronDistributeSponsorshipPrizes(requestParameters: GetCronDistributeSponsorshipPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Gets all guild members across all guilds ranked by monthly or cumulative points
     * @param {string} leaderboardTimeParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    getGlobalMonthlyGuildLeaderboardLeaderboardTimeParamRaw(requestParameters: GetGlobalMonthlyGuildLeaderboardLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGlobalMonthlyGuildLeaderboardResponse>>;

    /**
     * Gets all guild members across all guilds ranked by monthly or cumulative points
     */
    getGlobalMonthlyGuildLeaderboardLeaderboardTimeParam(requestParameters: GetGlobalMonthlyGuildLeaderboardLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGlobalMonthlyGuildLeaderboardResponse>;

    /**
     * Get list of all event types
     * @param {string} [game] ID of the game to filter quests by
     * @param {string} [guild] 
     * @param {string} [search] 
     * @param {GetQuestActiveStatus} [isActive] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    getGuildQuestsRaw(requestParameters: GetGuildQuestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGuildQuestsResponse>>;

    /**
     * Get list of all event types
     */
    getGuildQuests(requestParameters: GetGuildQuestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGuildQuestsResponse>;

    /**
     * Should get a list of guilds.
     * @param {Array<string>} [gameIds] 
     * @param {string} [search] 
     * @param {GetGuildsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    getGuildsRaw(requestParameters: GetGuildsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGuildsResponse>>;

    /**
     * Should get a list of guilds.
     */
    getGuilds(requestParameters: GetGuildsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGuildsResponse>;

    /**
     * Retrieves Guild data.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    getGuildsIdRaw(requestParameters: GetGuildsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Guild>>;

    /**
     * Retrieves Guild data.
     */
    getGuildsId(requestParameters: GetGuildsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Guild>;

    /**
     * Should get the current user\'s progress in a specific guild.
     * @param {string} id 
     * @param {boolean} [freshCopy] If true, bypasses cache and fetches fresh data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    getGuildsIdProgressRaw(requestParameters: GetGuildsIdProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGuildProgressResponse>>;

    /**
     * Should get the current user\'s progress in a specific guild.
     */
    getGuildsIdProgress(requestParameters: GetGuildsIdProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGuildProgressResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    getGuildsOwnershipsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGuildOwnershipResponse>>;

    /**
     */
    getGuildsOwnerships(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGuildOwnershipResponse>;

    /**
     * Get All Sponsored Guild Competitions
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    getSponsoredGuildCompetitionsRaw(requestParameters: GetSponsoredGuildCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSponsoredGuildCompetitionsResponse>>;

    /**
     * Get All Sponsored Guild Competitions
     */
    getSponsoredGuildCompetitions(requestParameters: GetSponsoredGuildCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSponsoredGuildCompetitionsResponse>;

    /**
     * Gets top guild leader rankings, sorted by total points or monthly points
     * @param {string} leaderboardTimeParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    getTopGuildLeadersLeaderboardTimeParamRaw(requestParameters: GetTopGuildLeadersLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTopGuildLeadersLeaderboardResponse>>;

    /**
     * Gets top guild leader rankings, sorted by total points or monthly points
     */
    getTopGuildLeadersLeaderboardTimeParam(requestParameters: GetTopGuildLeadersLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTopGuildLeadersLeaderboardResponse>;

    /**
     * Gets top guild rankings, sorted by total points or monthly points
     * @param {string} leaderboardTimeParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    getTopGuildsLeaderboardTimeParamRaw(requestParameters: GetTopGuildsLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTopGuildsLeaderboardResponse>>;

    /**
     * Gets top guild rankings, sorted by total points or monthly points
     */
    getTopGuildsLeaderboardTimeParam(requestParameters: GetTopGuildsLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTopGuildsLeaderboardResponse>;

    /**
     * Gets user\'s guild top 50 members, sorted by total points or monthly points
     * @param {string} leaderboardTimeParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    getUserGuildTopMembersLeaderboardTimeParamRaw(requestParameters: GetUserGuildTopMembersLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCurrentGuildTopMembersResponse>>;

    /**
     * Gets user\'s guild top 50 members, sorted by total points or monthly points
     */
    getUserGuildTopMembersLeaderboardTimeParam(requestParameters: GetUserGuildTopMembersLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCurrentGuildTopMembersResponse>;

    /**
     * Dismisses the won competition for the user.
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    updateCompetitionsWonDismissIdRaw(requestParameters: UpdateCompetitionsWonDismissIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Dismisses the won competition for the user.
     */
    updateCompetitionsWonDismissId(requestParameters: UpdateCompetitionsWonDismissIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates a quest in the system
     * @param {string} id 
     * @param {AddGuildQuestBody} [addGuildQuestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    updateGuildQuestsIdRaw(requestParameters: UpdateGuildQuestsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Updates a quest in the system
     */
    updateGuildQuestsId(requestParameters: UpdateGuildQuestsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates a guild in the system
     * @param {string} id 
     * @param {AddGuildBody} [addGuildBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    updateGuildsIdRaw(requestParameters: UpdateGuildsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Updates a guild in the system
     */
    updateGuildsId(requestParameters: UpdateGuildsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to create new Guild quest
     * @param {UpdateSponsoredCompetitionBody} [updateSponsoredCompetitionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuildsApiInterface
     */
    updateSponsoredGuildCompetitionsRaw(requestParameters: UpdateSponsoredGuildCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to create new Guild quest
     */
    updateSponsoredGuildCompetitions(requestParameters: UpdateSponsoredGuildCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class GuildsApi extends runtime.BaseAPI implements GuildsApiInterface {

    /**
     * Used to create new Guild quest
     */
    async createGuildQuestsRaw(requestParameters: CreateGuildQuestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/guild-quests`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddGuildQuestBodyToJSON(requestParameters['addGuildQuestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to create new Guild quest
     */
    async createGuildQuests(requestParameters: CreateGuildQuestsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createGuildQuestsRaw(requestParameters, initOverrides);
    }

    /**
     * Should allow a user to claim a guild-specific quest reward.
     */
    async createGuildQuestsIdClaimRaw(requestParameters: CreateGuildQuestsIdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimGuildQuestResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createGuildQuestsIdClaim().'
            );
        }

        if (requestParameters['guildId'] == null) {
            throw new runtime.RequiredError(
                'guildId',
                'Required parameter "guildId" was null or undefined when calling createGuildQuestsIdClaim().'
            );
        }

        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError(
                'gameId',
                'Required parameter "gameId" was null or undefined when calling createGuildQuestsIdClaim().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['guildId'] != null) {
            queryParameters['guildId'] = requestParameters['guildId'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['rewardConfigId'] != null) {
            queryParameters['rewardConfigId'] = requestParameters['rewardConfigId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/guild-quests/{id}/claim`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimGuildQuestResponseFromJSON(jsonValue));
    }

    /**
     * Should allow a user to claim a guild-specific quest reward.
     */
    async createGuildQuestsIdClaim(requestParameters: CreateGuildQuestsIdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimGuildQuestResponse> {
        const response = await this.createGuildQuestsIdClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a new guild to the system
     */
    async createGuildsRaw(requestParameters: CreateGuildsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Guild>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/guilds`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddGuildBodyToJSON(requestParameters['addGuildBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GuildFromJSON(jsonValue));
    }

    /**
     * Adds a new guild to the system
     */
    async createGuilds(requestParameters: CreateGuildsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Guild> {
        const response = await this.createGuildsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Should allow a user to join a guild.
     */
    async createGuildsIdJoinRaw(requestParameters: CreateGuildsIdJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createGuildsIdJoin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/guilds/{id}/join`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Should allow a user to join a guild.
     */
    async createGuildsIdJoin(requestParameters: CreateGuildsIdJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createGuildsIdJoinRaw(requestParameters, initOverrides);
    }

    /**
     * Should mint the guild proof of play badge to the user\'s wallet.
     */
    async createGuildsIdMintRaw(requestParameters: CreateGuildsIdMintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NftMintTransaction>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createGuildsIdMint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/guilds/{id}/mint`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NftMintTransactionFromJSON(jsonValue));
    }

    /**
     * Should mint the guild proof of play badge to the user\'s wallet.
     */
    async createGuildsIdMint(requestParameters: CreateGuildsIdMintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NftMintTransaction> {
        const response = await this.createGuildsIdMintRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to create new Guild quest
     */
    async createSponsoredGuildCompetitionsRaw(requestParameters: CreateSponsoredGuildCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sponsored-guild-competitions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSponsoredCompetitionBodyToJSON(requestParameters['createSponsoredCompetitionBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to create new Guild quest
     */
    async createSponsoredGuildCompetitions(requestParameters: CreateSponsoredGuildCompetitionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createSponsoredGuildCompetitionsRaw(requestParameters, initOverrides);
    }

    /**
     * Duplicate an existing sponsored guild competition to a new month/year
     */
    async createSponsoredGuildCompetitionsIdDuplicateRaw(requestParameters: CreateSponsoredGuildCompetitionsIdDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createSponsoredGuildCompetitionsIdDuplicate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sponsored-guild-competitions/{id}/duplicate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DuplicateSponsoredCompetitionBodyToJSON(requestParameters['duplicateSponsoredCompetitionBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Duplicate an existing sponsored guild competition to a new month/year
     */
    async createSponsoredGuildCompetitionsIdDuplicate(requestParameters: CreateSponsoredGuildCompetitionsIdDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createSponsoredGuildCompetitionsIdDuplicateRaw(requestParameters, initOverrides);
    }

    /**
     * Should allow a user to leave a guild.
     */
    async deleteGuildsLeaveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/guilds/leave`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Should allow a user to leave a guild.
     */
    async deleteGuildsLeave(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteGuildsLeaveRaw(initOverrides);
    }

    /**
     * Gets any current competition + last months competition and winners
     */
    async getCompetitionInfoRaw(requestParameters: GetCompetitionInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitionInfoResponse>> {
        const queryParameters: any = {};

        if (requestParameters['test'] != null) {
            queryParameters['test'] = requestParameters['test'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competition-info`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompetitionInfoResponseFromJSON(jsonValue));
    }

    /**
     * Gets any current competition + last months competition and winners
     */
    async getCompetitionInfo(requestParameters: GetCompetitionInfoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitionInfoResponse> {
        const response = await this.getCompetitionInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get businesses owned by the current merchant, or all businesses if user is admin
     */
    async getCronDistributeSponsorshipPrizesRaw(requestParameters: GetCronDistributeSponsorshipPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['competitionId'] != null) {
            queryParameters['competitionId'] = requestParameters['competitionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/cron/distribute-sponsorship-prizes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to get businesses owned by the current merchant, or all businesses if user is admin
     */
    async getCronDistributeSponsorshipPrizes(requestParameters: GetCronDistributeSponsorshipPrizesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCronDistributeSponsorshipPrizesRaw(requestParameters, initOverrides);
    }

    /**
     * Gets all guild members across all guilds ranked by monthly or cumulative points
     */
    async getGlobalMonthlyGuildLeaderboardLeaderboardTimeParamRaw(requestParameters: GetGlobalMonthlyGuildLeaderboardLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGlobalMonthlyGuildLeaderboardResponse>> {
        if (requestParameters['leaderboardTimeParam'] == null) {
            throw new runtime.RequiredError(
                'leaderboardTimeParam',
                'Required parameter "leaderboardTimeParam" was null or undefined when calling getGlobalMonthlyGuildLeaderboardLeaderboardTimeParam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/global-monthly-guild-leaderboard/{leaderboardTimeParam}`;
        urlPath = urlPath.replace(`{${"leaderboardTimeParam"}}`, encodeURIComponent(String(requestParameters['leaderboardTimeParam'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGlobalMonthlyGuildLeaderboardResponseFromJSON(jsonValue));
    }

    /**
     * Gets all guild members across all guilds ranked by monthly or cumulative points
     */
    async getGlobalMonthlyGuildLeaderboardLeaderboardTimeParam(requestParameters: GetGlobalMonthlyGuildLeaderboardLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGlobalMonthlyGuildLeaderboardResponse> {
        const response = await this.getGlobalMonthlyGuildLeaderboardLeaderboardTimeParamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of all event types
     */
    async getGuildQuestsRaw(requestParameters: GetGuildQuestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGuildQuestsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['game'] != null) {
            queryParameters['game'] = requestParameters['game'];
        }

        if (requestParameters['guild'] != null) {
            queryParameters['guild'] = requestParameters['guild'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/guild-quests`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGuildQuestsResponseFromJSON(jsonValue));
    }

    /**
     * Get list of all event types
     */
    async getGuildQuests(requestParameters: GetGuildQuestsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGuildQuestsResponse> {
        const response = await this.getGuildQuestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Should get a list of guilds.
     */
    async getGuildsRaw(requestParameters: GetGuildsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGuildsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['gameIds'] != null) {
            queryParameters['gameIds'] = requestParameters['gameIds'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/guilds`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGuildsResponseFromJSON(jsonValue));
    }

    /**
     * Should get a list of guilds.
     */
    async getGuilds(requestParameters: GetGuildsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGuildsResponse> {
        const response = await this.getGuildsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves Guild data.
     */
    async getGuildsIdRaw(requestParameters: GetGuildsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Guild>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getGuildsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/guilds/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GuildFromJSON(jsonValue));
    }

    /**
     * Retrieves Guild data.
     */
    async getGuildsId(requestParameters: GetGuildsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Guild> {
        const response = await this.getGuildsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Should get the current user\'s progress in a specific guild.
     */
    async getGuildsIdProgressRaw(requestParameters: GetGuildsIdProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGuildProgressResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getGuildsIdProgress().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['freshCopy'] != null) {
            queryParameters['freshCopy'] = requestParameters['freshCopy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/guilds/{id}/progress`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGuildProgressResponseFromJSON(jsonValue));
    }

    /**
     * Should get the current user\'s progress in a specific guild.
     */
    async getGuildsIdProgress(requestParameters: GetGuildsIdProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGuildProgressResponse> {
        const response = await this.getGuildsIdProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getGuildsOwnershipsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGuildOwnershipResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/guilds/ownerships`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGuildOwnershipResponseFromJSON(jsonValue));
    }

    /**
     */
    async getGuildsOwnerships(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGuildOwnershipResponse> {
        const response = await this.getGuildsOwnershipsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get All Sponsored Guild Competitions
     */
    async getSponsoredGuildCompetitionsRaw(requestParameters: GetSponsoredGuildCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSponsoredGuildCompetitionsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sponsored-guild-competitions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSponsoredGuildCompetitionsResponseFromJSON(jsonValue));
    }

    /**
     * Get All Sponsored Guild Competitions
     */
    async getSponsoredGuildCompetitions(requestParameters: GetSponsoredGuildCompetitionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSponsoredGuildCompetitionsResponse> {
        const response = await this.getSponsoredGuildCompetitionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets top guild leader rankings, sorted by total points or monthly points
     */
    async getTopGuildLeadersLeaderboardTimeParamRaw(requestParameters: GetTopGuildLeadersLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTopGuildLeadersLeaderboardResponse>> {
        if (requestParameters['leaderboardTimeParam'] == null) {
            throw new runtime.RequiredError(
                'leaderboardTimeParam',
                'Required parameter "leaderboardTimeParam" was null or undefined when calling getTopGuildLeadersLeaderboardTimeParam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/top-guild-leaders/{leaderboardTimeParam}`;
        urlPath = urlPath.replace(`{${"leaderboardTimeParam"}}`, encodeURIComponent(String(requestParameters['leaderboardTimeParam'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTopGuildLeadersLeaderboardResponseFromJSON(jsonValue));
    }

    /**
     * Gets top guild leader rankings, sorted by total points or monthly points
     */
    async getTopGuildLeadersLeaderboardTimeParam(requestParameters: GetTopGuildLeadersLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTopGuildLeadersLeaderboardResponse> {
        const response = await this.getTopGuildLeadersLeaderboardTimeParamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets top guild rankings, sorted by total points or monthly points
     */
    async getTopGuildsLeaderboardTimeParamRaw(requestParameters: GetTopGuildsLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTopGuildsLeaderboardResponse>> {
        if (requestParameters['leaderboardTimeParam'] == null) {
            throw new runtime.RequiredError(
                'leaderboardTimeParam',
                'Required parameter "leaderboardTimeParam" was null or undefined when calling getTopGuildsLeaderboardTimeParam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/top-guilds/{leaderboardTimeParam}`;
        urlPath = urlPath.replace(`{${"leaderboardTimeParam"}}`, encodeURIComponent(String(requestParameters['leaderboardTimeParam'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTopGuildsLeaderboardResponseFromJSON(jsonValue));
    }

    /**
     * Gets top guild rankings, sorted by total points or monthly points
     */
    async getTopGuildsLeaderboardTimeParam(requestParameters: GetTopGuildsLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTopGuildsLeaderboardResponse> {
        const response = await this.getTopGuildsLeaderboardTimeParamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets user\'s guild top 50 members, sorted by total points or monthly points
     */
    async getUserGuildTopMembersLeaderboardTimeParamRaw(requestParameters: GetUserGuildTopMembersLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCurrentGuildTopMembersResponse>> {
        if (requestParameters['leaderboardTimeParam'] == null) {
            throw new runtime.RequiredError(
                'leaderboardTimeParam',
                'Required parameter "leaderboardTimeParam" was null or undefined when calling getUserGuildTopMembersLeaderboardTimeParam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user-guild-top-members/{leaderboardTimeParam}`;
        urlPath = urlPath.replace(`{${"leaderboardTimeParam"}}`, encodeURIComponent(String(requestParameters['leaderboardTimeParam'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCurrentGuildTopMembersResponseFromJSON(jsonValue));
    }

    /**
     * Gets user\'s guild top 50 members, sorted by total points or monthly points
     */
    async getUserGuildTopMembersLeaderboardTimeParam(requestParameters: GetUserGuildTopMembersLeaderboardTimeParamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCurrentGuildTopMembersResponse> {
        const response = await this.getUserGuildTopMembersLeaderboardTimeParamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Dismisses the won competition for the user.
     */
    async updateCompetitionsWonDismissIdRaw(requestParameters: UpdateCompetitionsWonDismissIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCompetitionsWonDismissId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competitions-won/dismiss/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Dismisses the won competition for the user.
     */
    async updateCompetitionsWonDismissId(requestParameters: UpdateCompetitionsWonDismissIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCompetitionsWonDismissIdRaw(requestParameters, initOverrides);
    }

    /**
     * Updates a quest in the system
     */
    async updateGuildQuestsIdRaw(requestParameters: UpdateGuildQuestsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateGuildQuestsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/guild-quests/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddGuildQuestBodyToJSON(requestParameters['addGuildQuestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates a quest in the system
     */
    async updateGuildQuestsId(requestParameters: UpdateGuildQuestsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateGuildQuestsIdRaw(requestParameters, initOverrides);
    }

    /**
     * Updates a guild in the system
     */
    async updateGuildsIdRaw(requestParameters: UpdateGuildsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateGuildsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/guilds/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddGuildBodyToJSON(requestParameters['addGuildBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates a guild in the system
     */
    async updateGuildsId(requestParameters: UpdateGuildsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateGuildsIdRaw(requestParameters, initOverrides);
    }

    /**
     * Used to create new Guild quest
     */
    async updateSponsoredGuildCompetitionsRaw(requestParameters: UpdateSponsoredGuildCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sponsored-guild-competitions`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSponsoredCompetitionBodyToJSON(requestParameters['updateSponsoredCompetitionBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to create new Guild quest
     */
    async updateSponsoredGuildCompetitions(requestParameters: UpdateSponsoredGuildCompetitionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSponsoredGuildCompetitionsRaw(requestParameters, initOverrides);
    }

}
